import Chart from "chart.js/auto";

function formatNumberWithCommas(number) {
    const parts = number.toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

export default {
    mounted() {
        this.initChart();
    },

    initChart() {
        const ctx = this.el.getContext("2d");
        const data = JSON.parse(this.el.dataset.points);

        this.chart = new Chart(ctx, {
            type: "line",
            data: {
                labels: data.map((d) => d.label),
                datasets: [
                    {
                        label: "Revenue",
                        data: data.map((d) => d.value),
                        fill: true,
                        backgroundColor: "rgba(34, 197, 94, 0.1)",
                        borderColor: "rgb(34, 197, 94)",
                        borderWidth: 2,
                        tension: 0.4,
                        pointBackgroundColor: "rgb(34, 197, 94)",
                        pointBorderColor: "#fff",
                        pointBorderWidth: 2,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                devicePixelRatio: window.devicePixelRatio || 1,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        padding: 12,
                        titleFont: {
                            size: 14,
                        },
                        bodyFont: {
                            size: 14,
                        },
                        callbacks: {
                            label: function (context) {
                                return "$" + formatNumberWithCommas(context.parsed.y) + " USDC";
                            },
                        },
                    },
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            callback: function (value) {
                                return "$" + formatNumberWithCommas(value);
                            },
                        },
                        grid: {
                            color: "rgba(0, 0, 0, 0.05)",
                        },
                    },
                    x: {
                        grid: {
                            display: false,
                        },
                    },
                },
            },
        });
    },

    updated() {
        if (this.chart) {
            this.chart.destroy();
        }
        this.initChart();
    },

    destroyed() {
        if (this.chart) {
            this.chart.destroy();
        }
    },
};
